import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sex-options"
export default class extends Controller {
  static targets = ["select"];
  static values = {
    livestockType: String
  };

  static NON_MIXED_LIVESTOCK_TYPES = ["dairy"];
  static BASE_OPTIONS = ["Male", "Female", "Mixed"];
  static MIXED_OPTION = "Mixed";

  connect() {
    this.updateOptions();
  }

  updateOptions() {
    if (!this.hasSelectTarget) return;

    const sexOptions = this.getSexOptionsForLivestockType(this.livestockTypeValue);
    this.updateSelectOptions(sexOptions);
  }

  updateOptionsForLivestockType(event) {
    const livestockType = event.detail.livestockType;
    this.livestockTypeValue = livestockType;
    this.updateOptions();
  }

  getSexOptionsForLivestockType(livestockType) {
    const normalizedType = livestockType?.toLowerCase();
    
    if (this.isNonMixedLivestock(normalizedType)) {
      const filteredOptions = this.constructor.BASE_OPTIONS
        .filter(option => option !== this.constructor.MIXED_OPTION)
        .sort();
      return filteredOptions;
    }
    
    const allOptions = [...this.constructor.BASE_OPTIONS].sort();
    return allOptions;
  }

  isNonMixedLivestock(livestockType) {
    return this.constructor.NON_MIXED_LIVESTOCK_TYPES.includes(livestockType);
  }

  updateSelectOptions(sexOptions) {
    const select = this.selectTarget;
    
    // Store current value
    const currentValue = select.value;
    
    // Clear existing options
    select.innerHTML = "";
    
    // Add prompt option
    select.add(new Option(" ", ""));
    
    // Add new options
    sexOptions.forEach(option => {
      select.add(new Option(option, option));
    });
    
    // Restore previous value if it still exists in new options
    if (sexOptions.includes(currentValue)) {
      select.value = currentValue;
    }
    
    // Reinitialize Materialize select
    M.FormSelect.init(select);
  }
}